import React, { useEffect } from 'react'
import styles from './constructor.styles'
import injectSheet from 'react-jss'
import posthog from 'posthog-js'

const Constructor = ({
  classes,
  Screen,
  options,
  accountType,
  forcedAccount,
  me
}) => {
  const finishSignupStep = me?.account?.finish_signup_status?.next_step?.type
  const finished = me?.account?.finish_signup_status?.finished

  useEffect(
    () => {
      posthog.capture('finish signup step', {
        step: finishSignupStep,
        finished
      })
    },
    [finishSignupStep, finished]
  )

  return (
    <div>
      <Screen
        options={options}
        accountType={accountType}
        forcedAccount={forcedAccount}
      />
    </div>
  )
}

export default injectSheet(styles)(Constructor)
